import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ILoginFlows } from "@domains/features/LoginFlow/entities/CommonLoginData";
const ReportContent = () => {
    const [userType, setUserType] = useState();
    const [userID, setUserID] = useState();
    const userId = useSelector((state) => state.accountDetailsReducer.userID);
    const guestUserID = useSelector((state) => state.LoginFlow.guestValidateMPIN.data.guestId);
    let checkUserData = async () => {
        if (!!userId) {
            setUserType(ILoginFlows.CLIENT);
            setUserID(userId);
        }
        if (!!guestUserID) {
            setUserType(ILoginFlows.GUEST);
            setUserID(guestUserID);
        }
    };
    useEffect(() => {
        checkUserData();
    }, [userId, guestUserID]);
    return (React.createElement(React.Fragment, null, userID ? (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "report-content mx-0" },
            React.createElement(Col, { lg: 12, className: "px-0" },
                React.createElement("div", { className: "report-content-outer grid-4-report-postlogin" },
                    React.createElement("ul", { className: "report-ul ps-0" },
                        React.createElement("li", { className: "report-ul-head" }, "Other Reports"),
                        React.createElement("li", null, "Contract Notes & Statements"),
                        React.createElement("li", null, "Delayed Payment Interest"),
                        React.createElement("li", null, " Days Pending LTCG")),
                    React.createElement("ul", { className: "report-ul ps-0" },
                        React.createElement("li", { className: "report-ul-head" }, "\u00A0"),
                        React.createElement("li", null, "DP Bills"),
                        React.createElement("li", null, "Subscription History"))))))) : (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "report-content mx-0" },
            React.createElement(Col, { lg: 12, className: "px-0" },
                React.createElement("div", { className: "report-content-outer" },
                    React.createElement("div", { className: "grid-3" },
                        React.createElement("ul", { className: "report-ul ps-0" },
                            React.createElement("li", { className: "report-ul-head" }, "Holdings"),
                            React.createElement(Link, { to: "/reports?reportName=Holding" },
                                React.createElement("li", null, "Holdings Report")),
                            React.createElement("li", null, "Corporate Actions"),
                            React.createElement("li", null, " DP wise holdings")),
                        React.createElement("ul", { className: "report-ul ps-0" },
                            React.createElement("li", { className: "report-ul-head" }, "Transaction Report"),
                            React.createElement("li", null, "Transaction Report"),
                            React.createElement("li", null, "Tradewise Exits"),
                            React.createElement("li", null, " DP Transaction Statement"),
                            React.createElement("li", null, " AGTS")),
                        React.createElement("ul", { className: "report-ul ps-0" },
                            React.createElement("li", { className: "report-ul-head" }, "Cost"),
                            React.createElement("li", null, "Cost Report"),
                            React.createElement("li", null, "Delayed Payment Interest"),
                            React.createElement("li", null, " MTF Interest Report"),
                            React.createElement("li", null, "DP Charges")),
                        React.createElement("ul", { className: "report-ul ps-0" },
                            React.createElement("li", { className: "report-ul-head" }, "Margin"),
                            React.createElement("li", null, "Margin Report"),
                            React.createElement("li", null, "Margin Statement"),
                            React.createElement("li", null, "Ageing & Shortfall Report")),
                        React.createElement("ul", { className: "report-ul ps-0" },
                            React.createElement("li", { className: "report-ul-head" }, "Contract Note"),
                            React.createElement("li", null, "Contract Note"),
                            React.createElement("li", null, "Bills Report")),
                        React.createElement("ul", { className: "report-ul ps-0" },
                            React.createElement("li", { className: "report-ul-head" }, "Cashflow"),
                            React.createElement("li", null, "Cashflow Report"),
                            React.createElement("li", null, "Bills Report")),
                        React.createElement("ul", { className: "report-ul ps-0" },
                            React.createElement("li", { className: "report-ul-head" }, "Other Reports"),
                            React.createElement("li", null, "AIF Statement"),
                            React.createElement("li", null, "Strcutured Product Statement")),
                        React.createElement("ul", { className: "report-ul ps-0" },
                            React.createElement("li", { className: "report-ul-head" }, "\u00A0"),
                            React.createElement("li", null, "Insurance Report"),
                            React.createElement("li", null, "Funding Reports"))),
                    React.createElement("div", null,
                        React.createElement("ul", { className: "report-ul ps-0" },
                            React.createElement("li", { className: "report-ul-head" }, "Tax"),
                            React.createElement(Link, { to: "/reports?reportName=Tax" },
                                React.createElement("li", null, "Tax Report")),
                            React.createElement("li", null, "Tax Summary"),
                            React.createElement("li", null, " Advance Tax"),
                            React.createElement("li", null, "Turnover Report"),
                            React.createElement("li", null, "TDS/TCS"),
                            React.createElement("li", null, "80C/ELSS"),
                            React.createElement("li", null, "Tax Harvesting Report"))))))))));
};
export default ReportContent;
function checkUserData() {
    throw new Error("Function not implemented.");
}
